var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 14.1841V45.1311L30.2892 55L54 45.1311L54 14.1841L30.2891 7L6 14.1841Z",
    fill: "#204751"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71637 13.2252L5 13.4371V14.1841V45.1311V45.8042L5.62358 46.0576L29.9127 55.9264L30.2937 56.0813L30.6734 55.9232L54.3843 46.0543L55 45.7981V45.1311L55 14.1841V13.4422L54.29 13.2271L30.5791 6.04296L30.2926 5.95615L30.0055 6.04107L5.71637 13.2252Z",
    stroke: "#56A8BD",
    strokeOpacity: 0.62,
    strokeWidth: 2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9273 16H18.0672C16.9242 16 16 16.9023 16 18.018V41.9766C16 43.0922 16.9242 44 18.0672 44H41.9273C43.0703 44 44 43.0922 44 41.982V18.018C44 16.9023 43.0703 16 41.9273 16ZM24.307 39.8602H20.1508V26.4945H24.307V39.8602ZM22.2289 24.6734C20.8945 24.6734 19.8172 23.5961 19.8172 22.2672C19.8172 20.9383 20.8945 19.8609 22.2289 19.8609C23.5578 19.8609 24.6352 20.9383 24.6352 22.2672C24.6352 23.5906 23.5578 24.6734 22.2289 24.6734ZM39.8602 39.8602H35.7094V33.3633C35.7094 31.8156 35.682 29.8195 33.5492 29.8195C31.3891 29.8195 31.0609 31.5094 31.0609 33.2539V39.8602H26.9156V26.4945H30.8969V28.3211H30.9516C31.5039 27.2711 32.8602 26.1609 34.8781 26.1609C39.0836 26.1609 39.8602 28.9281 39.8602 32.5266V39.8602Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4_44",
    x: 0,
    y: 0.912292,
    width: 60,
    height: 60.2502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4_44"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linked in.a8d393a37e767078a28819582a0d8d12.svg";
export { ForwardRef as ReactComponent };